import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { IoMdCheckmarkCircle } from "react-icons/io";

import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';

const imgUrl = process.env.REACT_APP_IMAGEURL

const AceAcreVille = () => {
    const hero = `${imgUrl}/AceAcreVille/mainFeed.jpg`;
    const logo = `${imgUrl}/AceAcreVille/logo.png`;

    const ph1 = `${imgUrl}/AceAcreVille/ameneties-1.jpg`;
    const ph2 = `${imgUrl}/AceAcreVille/ameneties-2.jpg`;
    const ph3 = `${imgUrl}/AceAcreVille/ameneties-3.jpg`;
    const ph4 = `${imgUrl}/AceAcreVille/ameneties-4.jpg`;
    const ph5 = `${imgUrl}/AceAcreVille/ameneties-5.jpg`;
    const ph6 = `${imgUrl}/AceAcreVille/ameneties-6.png`;
    const ph7 = `${imgUrl}/AceAcreVille/ameneties-7.webp`;
    const ph8 = `${imgUrl}/AceAcreVille/ameneties-8.jpg`;
    const ph9 = `${imgUrl}/AceAcreVille/ameneties-9.jpg`;
    const ph10 = `${imgUrl}/AceAcreVille/ameneties-10.jpg`;


    const location = useLocation();
    const [openImgModal, setOpenImgModal] = useState(false);

    const [selectedImgIndex, setSelectedImgIndex] = useState(null);
    const [activeImageType, setActiveImageType] = useState(null);

    const ameneties = [ph1, ph2, ph3, ph4, ph5]

    const interiors = [
        { id: 0, img: ph6, title: "Jewar Int. Airport" },
        { id: 1, img: ph7, title: "Upcoming Film City" },
        { id: 2, img: ph8, title: "Upcoming Olympic Park" },
        { id: 3, img: ph9, title: "Upcoming IT  Hub" },
        { id: 4, img: ph10, title: "Buddha Int. Circuit" },
    ]


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);


    const handleOpenModal = (index, type) => {
        setSelectedImgIndex(index);
        setActiveImageType(type);
        setOpenImgModal(true);
    }

    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[700px] bg-cover bg-center transition-all duration-500"
                style={{ backgroundImage: `url('${hero}')` }}
            ></div>

            <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
                <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[300px]">
                    <img src={logo} alt="logo" className="w-full h-full object-contain rounded-lg" />
                </div>
            </div>

            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div className="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                Ace Acreville is an ambitious residential project by the ACE Group, located in Sector 22A along the
                                Yamuna Expressway in Greater Noida. This development is designed to offer a luxurious and well
                                connected lifestyle, making it an attractive option for both homebuyers and investors. Here's a
                                detailed description
                            </p>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">Project Overview:</h2>
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Ace Acreville spans across <strong>100 acres</strong> of prime land and features <strong>residential plots</strong> ranging
                                        from 200 to 500 sqyrds (1800 to 4500 sq. ft) The project is RERA-approved (UPRERAPRJ248777),
                                        ensuring transparency and legal security. With a focus on modern infrastructure and green living, Ace
                                        Acreville aims to provide a serene yet convenient lifestyle.
                                    </p>
                                </div>
                            </section>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">Location Highlights:</h2>
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The project is strategically located near the Yamuna Expressway, offering excellent connectivity to
                                        key areas like Noida, Greater Noida, Delhi, and Agra. It is also in close proximity to major
                                        developments such as:
                                    </p>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-sm">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>Noida International Airport (Jewar)</strong> enhancing global connectivity.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>Buddh International Circuit</strong> India's premier motorsport destination.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                The upcoming <strong>Film City</strong> , which is expected to boost the region's entertainment and economic
                                                prospects.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </section>
                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">Amenities and Features:</h2>
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Ace Acreville is designed to cater to a modern and luxurious lifestyle with a wide range of amenities,
                                        including:
                                    </p>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-sm">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>A clubhouse</strong> with recreational facilities.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div> Landscaped gardens and open green spaces. </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                A <strong>meditation pod</strong> and yoga lawn for relaxation.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                Sports facilities, including an outdoor gym and skating rink.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                Dedicated areas for children and senior citizens.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                A <strong>musical fountain</strong>  and artificial lake, adding to the aesthetic appeal.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">Investment Potential:</h2>
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The project's location near significant infrastructure developments like the Jewar Airport and Film
                                        City makes it a promising investment opportunity. The area is witnessing rapid growth, and property
                                        values are expected to appreciate over time.
                                    </p>
                                </div>
                            </section>
                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">Pricing and Availability:</h2>
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The plots are available in various sizes, with prices starting at approximately ₹2.60 Cr and going up to
                                        ₹6.50 Cr, depending on the plot size and location within the project.
                                    </p>
                                </div>
                            </section>
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                Ace Acreville is more than just a residential project; it's a vision for a sustainable and luxurious
                                community. Whether you're looking to build your dream home or make a smart investment, this
                                project offers a blend of comfort, connectivity, and future growth potential.
                            </p>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">What makes property value trends in this area:</h2>
                                <p className="text-md text-gray-700 my-1 text-justify">
                                    The property values along the Yamuna Expressway have shown remarkable growth in recent years,
                                    and the trend is expected to continue due to several factors:                                </p>
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Historical Growth:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Over the past five years, land prices in the area have surged by an
                                        impressive 450%, while apartment prices have increased by 170%. This growth is attributed to the
                                        development of key infrastructure projects.                                     </p>
                                </div>

                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Upcoming Developments :</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The construction of the Noida International Airport at Jewar, the
                                        expansion of the Delhi-Mumbai Industrial Corridor (DMIC), and the establishment of the Film City are
                                        expected to further boost property values.                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Future Potential  :</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        With the ongoing infrastructure projects and increasing demand for
                                        residential and commercial spaces, property values are likely to appreciate significantly in the coming
                                        years.                </p>                </div>
                            </section>

                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                The Yamuna Expressway is emerging as a prime investment hub in the Delhi-NCR region, making it an
                                attractive option for both homebuyers and investors.    .
                            </p>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            <div className="max-w-7xl mx-auto p-4">
                <h2 className="text-2xl font-semibold text-gray-800 my-4">
                    Projects Highlights
                </h2>
                {openImgModal && activeImageType === "ameneties" && (
                    <ImageModal
                        images={ameneties}
                        openImg={openImgModal}
                        selectedImgIndex={selectedImgIndex}
                        onClose={() => setOpenImgModal(false)}
                    />
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {ameneties.map((data, index) => (
                        <div
                            key={index}
                            onClick={() => handleOpenModal(index, "ameneties")}
                            className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                        >
                            <img
                                src={data}
                                alt="img"
                                className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                            />
                        </div>
                    ))}
                </div>
            </div>
            {openImgModal && activeImageType === "interiors" && (
                <ImageModal
                    images={interiors.map((item) => item.img)}
                    openImg={openImgModal}
                    selectedImgIndex={selectedImgIndex}
                    onClose={() => setOpenImgModal(false)}
                />
            )}

            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                {interiors.map((data, index) => (
                    <div key={index}
                        onClick={() => handleOpenModal(index, "interiors")}
                        className="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden bg-white">
                        <div className="relative">
                            <img
                                src={data.img}
                                alt={data.title}
                                className="w-full h-56 object-cover transition-transform duration-300 transform hover:scale-105"
                            />
                        </div>
                        <div className="px-5 py-3">
                            <h3 className="text-gray-700 font-semibold">{data.title}</h3>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default AceAcreVille